import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

import config from "appConfig";

const items = [
  {
    id: "f3d25fa1-278a-4c53-b284-f10622ff0bc1",
    content: "Configuration 1",
    options: { image: `${config.ASSETS_URL}/03/21/task/task-2-conf-1.svg` },
  },
  {
    id: "de6986ac-67dc-42b2-abaf-84a0f2edb8bf",
    content: "Configuration 2",
    options: { image: `${config.ASSETS_URL}/03/21/task/task-2-conf-2.svg` },
  },
  {
    id: "55dd1626-16b5-4f44-8eeb-4acca0767fbb",
    content: "Configuration 3",
    options: { image: `${config.ASSETS_URL}/03/21/task/task-2-conf-3.svg` },
  },
  {
    id: "e1fc84cb-fe3c-49b0-a413-a961b090e739",
    content: "Configuration 4",
    options: { image: `${config.ASSETS_URL}/03/21/task/task-2-conf-4.svg` },
  },
  {
    id: "78268fb5-de26-439a-b1d3-dc080929b1e2",
    content: "Configuration 5",
    options: { image: `${config.ASSETS_URL}/03/21/task/task-2-conf-5.svg` },
  },
  {
    id: "8c9f653f-c621-4868-b9f5-6d5d7b4e1d47",
    content: "Configuration 6",
    options: { image: `${config.ASSETS_URL}/03/21/task/task-2-conf-6.svg` },
  },
];

export const task: Task = {
  id: "0f3c2e3c-a1bc-4814-bb5d-6607ba1b5778",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 3,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "de6986ac-67dc-42b2-abaf-84a0f2edb8bf",
    "55dd1626-16b5-4f44-8eeb-4acca0767fbb",
    "e1fc84cb-fe3c-49b0-a413-a961b090e739",
    "8c9f653f-c621-4868-b9f5-6d5d7b4e1d47",
  ],
};
